export default __webpack_public_path__ + "82b88786df3e49d1d29b7cd659a27cb5.svg";